<template>
  <el-dialog title="详情" :visible.sync="dialogVisible" width="1050px" @close="dialogClose" center top="10vh">
    <div class="detail">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基础信息" name="first">
          <div class="baseInfo">
            <div class="baseInfoContent">
              <div class="baseInfoContentItem">
                <span class="span1">对账单编号：</span>
                <span>{{ dialogData.settNo }}</span>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">标题：</span>
                <span>{{ dialogData.title }}</span>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">供应商：</span>
                <span>{{ dialogData.companyNameNew }}</span>
                <el-tooltip v-if="dialogData.companyNameOld !== dialogData.companyNameNew" placement="bottom" effect="light">
                  <div slot="content">
                    <span style="color: #999">原委托商名称：{{ dialogData.companyNameOld }}</span>
                  </div>
                  <i class="el-icon-warning" style="color: red; font-size: 18px; margin-right: 5px" />
                </el-tooltip>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">结算方式：</span>
                <span>{{ dialogData.settType === 1 ? '合同价' : '预结算价' }}</span>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne" style="width: 250px">
                  <span class="span1">差价：</span>
                  <span>{{ dialogData.taxPrice || 0 }}元</span>
                </div>
                <div style="width: 250px">
                  <span class="span1">合同价：</span>
                  <span>{{ dialogData.settlementPrice || 0 }}元</span>
                </div>
                <div style="width: 250px">
                  <span class="span1">预结算价：</span>
                  <span>{{ dialogData.taxSettPrice || 0 }}元</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">台账月汇总金额：</span>
                <span>{{ dialogData.statistics }}</span>
              </div>
            </div>
          </div>
          <div class="operation" v-if="dialogData.isDeduct === 1">
            <div class="operationTitle">
              <div class="line" />
              <span>抵扣对账单</span>
            </div>
            <div class="operationTable">
              <el-table :data="dialogData.table1" border>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="settNo" label="对账单编号" align="center" />
                <el-table-column prop="settlementPrice" label="抵扣费用" align="center" />
              </el-table>
            </div>
          </div>
          <div class="baseInfo" v-if="dialogData.status === 1 || dialogData.status === 2">
            <div class="baseInfoTitle">
              <div class="line" />
              <span>审核信息</span>
            </div>
            <div>
              <steps :step-data="stepData" :step-state="stepState" />
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>操作记录</span>
            </div>
            <div class="operationTable">
              <el-table :data="dialogData.operateRecordList" border>
                <el-table-column label="操作时间" align="center" width="160px">
                  <div slot-scope="scope">{{ scope.row.createTime | timeFormat }}</div>
                </el-table-column>
                <el-table-column prop="operateType" label="操作类型" align="center" />
                <el-table-column prop="operationName" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="结算费用" name="second">
          <div class="baseInfo">
            <div class="operationTable" style="margin-top: 0">
              <el-table :data="settlementData" border script>
                <el-table-column prop="supplierName" label="供应商" min-width="100" align="center" show-overflow-tooltip />
                <el-table-column label="结算类型" min-width="120" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.settlementType === 0 ? '库房' : '港口' }}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="港口/库房名称" min-width="150" align="center" show-overflow-tooltip />
                <el-table-column prop="standingBookMonth" label="台账月" align="center" show-overflow-tooltip />
                <el-table-column prop="taskDate" label="作业时间" align="center" show-overflow-tooltip />
                <el-table-column prop="taskNum" label="作业数量" min-width="150" align="center" show-overflow-tooltip />
                <el-table-column prop="taskType" label="作业类型" min-width="150" align="center" show-overflow-tooltip />
                <el-table-column label="结算方式" min-width="120" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.settlementStyle === 1 ? '合同价' : '预结算价' }}
                  </template>
                </el-table-column>
                <el-table-column prop="taxRate" label="税率" align="center" />
                <el-table-column prop="taxPrice" label="含税合同价" align="center" width="100px" show-overflow-tooltip />
                <el-table-column prop="taxPrice" label="含税预结算价" align="center" show-overflow-tooltip />
                <el-table-column prop="difPrice" label="差价" align="center" width="90px" />
              </el-table>
            </div>
            <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
              <span>共{{ settlementDataTotal }}条</span>
              <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="settlementDataTotal" @size-change="settlementSizeChange" @current-change="settlementCurrentChange" @prev-click="settlementCurrentChange" @next-click="settlementCurrentChange" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其它结算费用" name="third">
          <div class="baseInfo">
            <div class="operationTable" style="margin-top: 0">
              <el-table :data="otherSettlementData" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="costNum" label="费用编号" align="center" />
                <el-table-column prop="costTypeName" label="费用类型" align="center" />
                <el-table-column prop="costInstruction" label="费用说明" align="center" />
                <el-table-column prop="costTime" label="费用时间" align="center">
                  <template slot-scope="scope">{{ scope.row.costTime | timeFormat }} </template>
                </el-table-column>
                <el-table-column prop="taxRate" label="税率(%)" align="center" />
                <el-table-column prop="costAmount" label="含税价" align="center" />
                <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />
                <el-table-column prop="remark" label="说明" align="center" />
              </el-table>
            </div>
            <div class="paginationContainer" style="display: flex; align-items: center; padding: 10px 20px">
              <span>共{{ otherSettlementDataTotal }}条</span>
              <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="otherSettlementDataTotal" @size-change="otherSettlementSizeChange" @current-change="otherSettlementCurrentChange" @prev-click="otherSettlementCurrentChange" @next-click="otherSettlementCurrentChange" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="开票信息" v-if="dialogData.status !== 0 && dialogData.status !== 1" name="fourth">
          <div class="baseInfo">
            <div class="operationTable" style="margin-top: 0">
              <el-table :data="infoInvoice" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="invoiceNo" label="发票号码" align="center" />
                <el-table-column prop="invoiceCode" label="发票代码" align="center" />
                <el-table-column prop="invoicDate" label="发票日期" align="center" />
                <el-table-column prop="taxPrice" label="含税金额" align="center" />
                <el-table-column prop="price" label="不含税金额" align="center" />
                <el-table-column prop="taxRate" label="税率" align="center" />
                <el-table-column prop="taxRate" label="开票类型" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.invoiceType ? '补开票' : '正常开票' }}
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
     <!-- 导出按钮 -->
<!--     <div style="position: absolute; top: 70px; right: 30px;" v-if="activeName == 'second'">-->
<!--      <el-button type="text" @click="onClickExport">导出</el-button>-->
<!--    </div>-->
  </el-dialog>
</template>

<script>
  import { formatDateTime } from '@/config/mUtils';
  import { accountDetail, getInfoInvoice, getPageListSCFI, getPageListSOCI } from '@/service/getData';

  export default {
    name: 'info',
    data() {
      return {
        dialogVisible: false,
        settlementStyle: '',
        activeName: 'first',
        dialogData: {},
        stepData: [],
        operationData: [],
        settlementSearchForm: {
          id: '',
          type: 27,
          rows: 10,
          page: 1,
        },
        settlementData: [],
        settlementDataTotal: 0,
        otherSettlementSearchForm: {
          id: '',
          type: 27,
          rows: 10,
          page: 1,
        },
        otherSettlementData: [],
        otherSettlementDataTotal: 0,
        infoInvoice: [], // 详情 开票信息
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    filters: {
      timeFormat(time) {
        return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
      },
    },
    watch: {
      activeName(val) {
        if (val === 'second') {
          this.getPageListSCFI();
        } else if (val === 'third') {
          this.getPageListSOCI();
        }
      },
    },
    methods: {
      onClickExport() {
        this.$emit('exportData', this.settlementSearchForm)
      },
      dialogOpen(id) {
        this.dialogVisible = true;
        this.getDetail(id);
        this.getInfoInvoice(id);
      },
      async getDetail(id) {
        this.loading = true;
        const { status, data, message } = await accountDetail(id);
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.settlementStyle = data.settType;
        if (data.auditRecordList) {
          this.stepData = [];
          // 审核信息数据
          data.auditRecordList.forEach(res => {
            const str = this.strFormat(res.status);
            const state = res.status === 3 ? 'failure' : res.status === 2 ? 'success' : '';
            this.stepData.push({
              title: res.auditorName + str,
              time: res.createTime,
              state,
              remark: res.opinion,
            });
          });
        }
        this.settlementSearchForm.id = this.otherSettlementSearchForm.id = id;
        this.dialogData = data;
        this.dialogData.table1 = [
          {
            settNo: data.settNo,
            settlementPrice: data.settlementPrice,
          },
        ];
      },
      async getInfoInvoice(id) {
        const { status, data, message } = await getInfoInvoice(id);
        if (status !== 0) return this.$message.warning(message);
        this.infoInvoice = data;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      settlementSizeChange(rows) {
        this.settlementSearchForm.rows = rows;
        this.getPageListSCFI();
      },
      settlementCurrentChange(page) {
        this.settlementSearchForm.page = page;
        this.getPageListSCFI();
      },
      async getPageListSCFI() {
        const { status, message, data } = await getPageListSCFI(this.settlementSearchForm);
        if (status !== 0) return this.$message.warning(message);
        this.settlementData = data ? data.records : [];
        this.settlementDataTotal = data ? data.total : 0;
      },
      otherSettlementSizeChange(rows) {
        this.otherSettlementSearchForm.rows = rows;
        this.getPageListSOCI();
      },
      otherSettlementCurrentChange(page) {
        this.otherSettlementSearchForm.page = page;
        this.getPageListSOCI();
      },
      async getPageListSOCI() {
        const { status, message, data } = await getPageListSOCI(this.otherSettlementSearchForm);
        if (status !== 0) return this.$message.warning(message);
        this.otherSettlementData = data ? data.records : [];
        this.otherSettlementDataTotal = data ? data.total : 0;
      },
      // 格式化审核信息状态
      strFormat(val) {
        let returnStr = '';
        switch (val) {
          case 0:
            returnStr = ' 重新发起';
            break;
          case 1:
            returnStr = ' 发起';
            break;
          case 2:
            returnStr = ' 同意';
            break;
          case 3:
            returnStr = ' 拒绝';
            break;
          case 4:
            returnStr = ' 取消审核';
            break;
          default:
            returnStr = '';
            break;
        }
        return returnStr;
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-table .cell {
      padding: 0;
    }

    .el-table th {
      padding: 0;
    }

    .el-table td {
      padding: 0;
    }
  }
</style>
